import { openobserveRum } from '@openobserve/browser-rum';
import { openobserveLogs } from '@openobserve/browser-logs';

// Additive, build-time-gated RUM bootstrap for frontend-calendar.
// Must never throw, never block render, and must no-op when the token is absent.
export function initRum() {
    try {
        if (typeof window === 'undefined') {
            return;
        }

        // OPENOBSERVE_CLIENT_TOKEN is a public, write-only RUM token injected at build time.
        const clientToken = process.env.REACT_APP_OPENOBSERVE_CLIENT_TOKEN;

        if (!clientToken) {
            return;
        }

        const sameOriginOrIncruiterHost = (url) => {
            try {
                const parsed = new URL(url, window.location.origin);
                return parsed.origin === window.location.origin || /(^|\.)incruiter\.com$/.test(parsed.hostname);
            } catch (e) {
                return false;
            }
        };

        const commonConfig = {
            applicationId: 'frontend-calendar',
            service: 'frontend-calendar',
            site: 'monitor.incruiter.com',
            organizationIdentifier: 'default',
            clientToken,
            env: 'development',
            version: '0.0.1',
            insecureHTTP: false,
            apiVersion: 'v1',
        };

        openobserveRum.init({
            ...commonConfig,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 20,
            defaultPrivacyLevel: 'mask',
            allowedTracingUrls: [sameOriginOrIncruiterHost],
            propagatorTypes: ['tracecontext', 'openobserve'],
        });

        openobserveRum.startSessionReplayRecording();

        openobserveLogs.init({
            ...commonConfig,
            forwardErrorsToLogs: true,
        });
    } catch (err) {
        console.warn('[rum] initRum failed to initialize', err);
    }
}
